import { Link } from "@tanstack/react-router";

export function NotFound() {
  return (
    <main className="mx-auto flex min-h-[100dvh] max-w-[680px] flex-col justify-center px-5 py-8 sm:px-6">
      <div className="font-sans text-[11px] uppercase tracking-[0.08em] text-fg-subtle">
        404 · this race doesn't exist
      </div>
      <h1 className="mt-2 font-mono tabular text-[88px] leading-[88px] tracking-[-0.04em] text-fg sm:text-[120px] sm:leading-[112px]">
        DNF
      </h1>
      <p className="mt-4 max-w-[50ch] font-sans text-[15px] leading-[22px] text-fg-muted">
        We couldn't find what you're looking for. Could be a stale share link,
        a race that hasn't been added to the calendar yet, or a profile that's
        been disconnected.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link
          to="/"
          className="rounded-full bg-accent px-5 py-2 font-sans text-[14px] font-medium text-white transition-transform hover:scale-[1.02]"
        >
          Back to the home stadium
        </Link>
        <Link
          to="/races"
          className="rounded-full border border-border-strong px-5 py-2 font-sans text-[14px] text-fg transition-colors hover:border-accent"
        >
          Open the calendar
        </Link>
      </div>
      <footer className="mt-20 border-t border-border pt-6 font-sans text-[12px] text-fg-subtle">
        Every PB is a BOOM · RUNBOOM
      </footer>
    </main>
  );
}
